export const typedEntries = <T extends object>(
  object: T,
  // oxlint-disable-next-line bank/no-object-entries -- this is the typed wrapper
): [keyof T, T[keyof T]][] => Object.entries(object) as [keyof T, T[keyof T]][];
